import React, { Fragment } from "react"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { FaCog, FaLock, FaRegListAlt, FaSearch } from "react-icons/fa"
import { GrClose } from "react-icons/gr"
import { PiPrinter } from "react-icons/pi"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth } from "utils"
import { IconButton } from "components"
import { hideFoodSidebar, openPinModal, toggleFoodSearchBar } from "@redux"
import classes from "./FoodSidebarHeader.module.scss"

const FoodSidebarHeader = () => {
  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const foodPageUiState =
    useSelector(state => state.foodPageUiState)

  const cashierPin =
    useSelector(state =>
      state.userAccountInfo.cashierPin
    )

  const notViewedOrders =
    useSelector(state => state.notViewedOrders.notViewedOrders)

  const totalFailedPrints =
    useSelector(state => state.failedPrints.length)

  const notViewedOfflineOrders =
    useSelector(state =>
      state.offlineOrders.filter(o => !o.isViewed).length
    )

  const handleToggleSearch = () => {
    dispatch(
      toggleFoodSearchBar()
    )
  }

  const handleNavigate = () => {
    history.push("/failed-printers")
  }

  const showsOrdersIcon =
    haveAuth([
      "viewOrderHistory",
      "viewUnconfirmedOrders",
      "viewLatestOrders"
    ],
      "needOneOfAccesses"
    )

  const totalNotViewedOrders =
    notViewedOrders.notConfirmed +
    notViewedOrders.pending +
    notViewedOrders.paid +
    notViewedOrders.canceled +
    notViewedOfflineOrders

  const showFailedPrintIcon =
    totalFailedPrints !== 0 &&
    haveAuth(["printerAccess"])

  const showLockScreen = !!cashierPin

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div
        className={clsx(
          classes["container-mobile"],
          isLtr && classes["container-mobile-ltr"]
        )}
      >
        <span className={classes["title"]}>
          {t("سبد_خرید")}
        </span>
        <IconButton
          icon={MdClose}
          size={25}
          color="white"
          onClick={() => dispatch(hideFoodSidebar())}
        />
      </div>

      <div
        className={clsx(
          classes["container-dekstop"],
          isLtr && classes["container-dekstop-ltr"]
        )}
      >
        <IconButton
          tooltip={t("قفل_صفحه")}
          disabled={!showLockScreen}
          icon={FaLock}
          className={classes["icon-lock"]}
          color="white"
          size={25}
          onClick={() => dispatch(openPinModal())}
        />
        <IconButton
          tooltip={t("پرینت_های_انجام_نشده")}
          disabled={!showFailedPrintIcon}
          icon={PiPrinter}
          color="white"
          className={classes["icon"]}
          badge={totalFailedPrints}
          size={25}
          onClick={handleNavigate}
        />
        {
          showsOrdersIcon &&
          <IconButton
            icon={FaRegListAlt}
            color="white"
            size={25}
            className={classes["icon"]}
            badge={totalNotViewedOrders}
            onClick={() => history.push("/orders")}
          />
        }
        <IconButton
          icon={FaCog}
          color="white"
          size={25}
          className={classes["icon"]}
          onClick={() => history.push("/settings")}
        />

        <IconButton
          icon={foodPageUiState.searchBar ? GrClose : FaSearch}
          color="white"
          className={classes["icon"]}
          size={25}
          onClick={handleToggleSearch}
        />
      </div>
    </Fragment>
  )
}

export default React.memo(FoodSidebarHeader)